export const SET_FAVORITES = 'SET_FAVORITES';
export const SET_DIALOG = 'SET_DIALOG';
export const SET_FORUM_VOTES = 'SET_FORUM_VOTES';
export const APP_DOWNLOAD_DIALOG_OPEN = 'APP_DOWNLOAD_DIALOG_OPEN';
